import { render, staticRenderFns } from "./OrderDetailsGrid.vue?vue&type=template&id=2a7a11e8&scoped=true"
import script from "./OrderDetailsGrid.vue?vue&type=script&lang=js"
export * from "./OrderDetailsGrid.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsGrid.vue?vue&type=style&index=0&id=2a7a11e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a11e8",
  null
  
)

export default component.exports